// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Reprise ou échec d'API
export default class ObjetMetier  {
  // Identifiant unique
  public id: number;
  // Service
  public basePath: string;
  // Opération
  public entryPoint: string;
  // Destinataire
  public destination: string;
  // Objet
  public subject: string;
  // Nombre de tentatives
  public retryCount: number;
  // Abandonnée
  public abandoned: boolean;
  // Prochaine tentative
  public date: Date;
  // Dernier échec
  public lastError: string;
  // Données
  public data: string;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.basePath = '';
    this.entryPoint = '';
    this.destination = '';
    this.subject = '';
    this.retryCount = 0;
    this.abandoned = false;
    this.date = new Date(1901,1,1,0,0,0,0);
    this.lastError = '';
    this.data = '';
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: ObjetMetier): ObjetMetier {
    const newObjetMetier: ObjetMetier = new ObjetMetier();
    newObjetMetier.id = obj.id;
    newObjetMetier.basePath = obj.basePath;
    newObjetMetier.entryPoint = obj.entryPoint;
    newObjetMetier.destination = obj.destination;
    newObjetMetier.subject = obj.subject;
    newObjetMetier.retryCount = obj.retryCount;
    newObjetMetier.abandoned = obj.abandoned;
    newObjetMetier.date = new Date(obj.date);
    newObjetMetier.lastError = obj.lastError;
    newObjetMetier.data = obj.data;
    newObjetMetier.createId = obj.createId;
    newObjetMetier.failed = obj.failed;
    newObjetMetier.canUpdate = obj.canUpdate;
    newObjetMetier.canDelete = obj.canDelete;
    newObjetMetier.display = obj.display;
    newObjetMetier.notifDefType = obj.notifDefType;
    return newObjetMetier;
  }

  public toJsonObjetMetier (): string {
    const json = {
      basePath: this.basePath,
      entryPoint: this.entryPoint,
      destination: this.destination,
      subject: this.subject,
      retryCount: this.retryCount,
      abandoned: this.abandoned,
      date: this.date ? new Date (this.date).toString() : this.date,
      lastError: this.lastError,
      data: this.data,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromObjetMetier (obj: ObjetMetier): void {
    this.id = obj.id;
    this.basePath = obj.basePath;
    this.entryPoint = obj.entryPoint;
    this.destination = obj.destination;
    this.subject = obj.subject;
    this.retryCount = obj.retryCount;
    this.abandoned = obj.abandoned;
    this.date = new Date(obj.date);
    this.lastError = obj.lastError;
    this.data = obj.data;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareObjetMetier (value: ObjetMetier): boolean {
    return (this.toJsonObjetMetier() == value.toJsonObjetMetier());
  }

  public cloneObjetMetier (): ObjetMetier {
    return ObjetMetier.fromJson(this);
  }

  public deleteForStoreObjetMetier (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/objetmetiers/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/objetmetiers/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static synchro (): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/objetmetiers/synchro', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static verifEcritures (): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/objetmetiers/verifEcritures', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/ObjetMetiers/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = ObjetMetier.fromJson(listData.reccords[0] as ObjetMetier);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<ObjetMetier> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/ObjetMetiers/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = ObjetMetier.fromJson(listData.reccords[0] as ObjetMetier);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(objetMetiers: ObjetMetier[]) {
    objetMetiers.forEach((item) => {
      item.date = item.date ? new Date(item.date) : item.date;
    })
  }
}
